import { DnsSurface } from "@redotech/crdb-enums/dns/dns-surface";
import { domainRequirementsSchema } from "@redotech/redo-dns-common/schema";
import * as z from "zod";

/**
 * Called by a product whose own config changed. Claims the domain if needed,
 * then observes, so records are never derived from a zone we have not read.
 */
export const ensureDnsDomain = {
  name: "ensureDnsDomain" as const,
  input: z.object({
    domain: z.string(),
    /** Narrows the output only. Reconciliation runs across every surface. */
    surfaces: z.array(z.enum(DnsSurface)).optional(),
  }),
  output: z.object({ requirements: domainRequirementsSchema.nullable() }),
};
